import { useEffect } from 'react';

import { useOrgUiSettingsStore } from '../stores/orgUiSettingsStore';

/** Product name shown when the organization sets no `app_name`. */
export const DEFAULT_APP_NAME = 'GenieFactory';

/** The organization's `app_name` (ui_settings), or the product name. */
export function useAppName(): string {
  return useOrgUiSettingsStore((s) => s.settings?.app_name?.trim()) || DEFAULT_APP_NAME;
}

/** The organization's `tagline` (ui_settings), or null when unset. */
export function useOrgTagline(): string | null {
  return useOrgUiSettingsStore((s) => s.settings?.tagline?.trim()) || null;
}

/**
 * Browser tab title follows the org's `app_name`; without one, the title from
 * index.html is kept. Mount once in the authenticated layout.
 */
export function useApplyAppNameTitle(): void {
  const appName = useOrgUiSettingsStore((s) => s.settings?.app_name?.trim()) || null;

  useEffect(() => {
    if (!appName) return;
    const previous = document.title;
    document.title = appName;
    return () => {
      document.title = previous;
    };
  }, [appName]);
}
